module.exports = __webpack_public_path__ + "static_pc/img/ba15.5f68a1d9.png";